<div
  class="query-title-bar"
  #titleBar
  [class.has-reports]="
    routing.isChart() && (routing.isQuery() || routing.isSearch())
  "
>
  <div class="query-title-left">
    <div class="name-section">
      <span class="label">{{ label }}</span>
      <div class="name-row" [class.has-dropdown]="collectionQueries.length > 0">
        <span
          class="name"
          *ngIf="routing.isQuery()"
          matTooltipShowDelay="500"
          (click)="openQueryMenu()"
          >{{ name }}</span
        >
        <span
          class="name"
          *ngIf="!routing.isQuery()"
          [matTooltip]="name | nicetxt: false"
          matTooltipShowDelay="500"
          (click)="openQueryMenu()"
          >{{ name | nicetxt: false }}</span
        >
        <button
          *ngIf="collectionQueries.length > 0"
          #queryMenuTrigger="matMenuTrigger"
          class="query-switch-btn"
          mat-icon-button
          [matMenuTriggerFor]="queryPickerMenu"
          matTooltipShowDelay="500"
        >
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #queryPickerMenu="matMenu">
          <button
            mat-menu-item
            [style.background]="
              params.id === params.groupId ? 'rgb(50 50 50 / 85%)' : null
            "
            [style.font-weight]="params.id === params.groupId ? '600' : null"
            [style.height]="'auto'"
            [style.max-width]="'350px'"
            (click)="navigateToCollection()"
          >
            Overall
          </button>
          <button
            *ngFor="let q of collectionQueries"
            mat-menu-item
            [style.background]="
              q.uid === params.id ? 'rgb(50 50 50 / 85%)' : null
            "
            [style.font-weight]="q.uid === params.id ? '600' : null"
            [style.height]="'auto'"
            [style.max-width]="'350px'"
            (click)="navigateToQuery(q)"
          >
            {{ q.name }}
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="metrics-group">
      <div class="divider"></div>

      <div class="sentiment-section" *ngIf="titolo?.sentiment">
        <span class="label">Sentiment</span>
        <div class="score-row">
          <span
            class="score"
            [style.color]="titolo.sentiment.sentiment | color"
            >{{ titolo.sentiment.sentiment | percent }}</span
          >
          <span
            class="delta-pill"
            *ngIf="sentimentDelta !== 0"
            [class.negative]="sentimentDelta < 0"
            [class.positive]="sentimentDelta > 0"
          >
            {{ sentimentDelta | trend }}{{ displaySentimentDelta }}
          </span>
        </div>
      </div>

      <div
        class="divider"
        *ngIf="isLoadingEvents || scoreEventsCount !== null"
      ></div>

      <div
        class="events-section"
        *ngIf="isLoadingEvents || scoreEventsCount !== null"
      >
        <span class="label"
          >Events
          <span class="label-suffix" *ngIf="scoreEventsTimeframe"
            >(last {{ scoreEventsTimeframe }}d)</span
          ></span
        >
        <ng-container *ngIf="isLoadingEvents">
          <span class="skeleton skeleton-count"></span>
        </ng-container>
        <ng-container *ngIf="!isLoadingEvents">
          <div class="score-row">
            <span class="events-count" *ngIf="scoreEventsCount !== null">{{
              scoreEventsCount | thousandSuff
            }}</span>
            <span
              class="delta-pill neutral"
              *ngIf="scoreEventsDelta !== null && scoreEventsDelta !== 0"
            >
              {{ scoreEventsDelta | trend
              }}{{ displayEventsDelta | thousandSuff }}
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="title-spacer"></div>

  <div class="query-title-right">
    <div class="actions-section">
      <div class="actions-row">
        <button
          *ngIf="
            (!routing.isQuery() || params.id !== params.groupId) &&
            !isCollection
          "
          mat-stroked-button
          (click)="onEdit()"
        >
          <mat-icon>edit</mat-icon>
          <span>{{
            isNarrow ? 'Edit' : routing.isQuery() ? 'Edit Query' : 'Edit search'
          }}</span>
        </button>

        <button
          mat-stroked-button
          *ngIf="routing.isSearch()"
          [matMenuTriggerFor]="saveMenu"
        >
          <mat-icon>save</mat-icon>
          <span>Save</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #saveMenu="matMenu">
          <button mat-menu-item (click)="onSave('add')">
            Add to existing collection
          </button>
          <button mat-menu-item (click)="onSave('create')">
            Add to new collection
          </button>
        </mat-menu>

        <div
          class="divider"
          *ngIf="!routing.isQuery() || params.id !== params.groupId"
        ></div>

        <app-report-box
          *ngIf="
            titolo &&
            routing.isChart() &&
            !config.appConfig.setup.reportsDisabled
          "
          mode="query"
          buttonLabel="Report"
          [buttonLabelPrefix]="isBarNarrow ? '' : 'Due Diligence'"
        ></app-report-box>
      </div>
    </div>
  </div>
</div>
